<ui-card class="w-full h-full *:w-full *:h-full min-w-52 bg-white rounded-lg">
	<h3 card-header class="text-xl font-medium capitalize">Signers</h3>

	<div card-content>
		<div class="flex flex-col pb-4 gap-2">
			<p class="p-sm">
				Need to re-send the link? Just copy the recipient's unique signing link
				and send it their way.
			</p>
		</div>
		<ul class="list-none flex flex-col divide-y divide-gray-200 w-full">
			@for (recipient of sortedRecipients(); track recipient.id) {
				<li
					class="grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] items-center py-3 gap-4 w-full *:min-w-0"
				>
					<div class="flex items-center gap-4">
						<ui-avatar
							[initials]="recipient.initials"
							[variant]="variantOrderList[$index % variantOrderList.length]"
						/>
						<div class="flex-col gap-2 items-center truncate">
							<h6 class="text-gray-900 text-sm">
								{{ recipient.name }}
							</h6>
							<p class="p-xs text-gray-500 not-italic">
								{{ recipient.email }}
							</p>
						</div>
					</div>
					<ui-status [status]="recipient.status" />
					<ui-button
						[disabled]="envelopeStatus() === STATUSES.CANCELLED"
						preset="EXTRA_LOW_EMPHASIS"
						label="Copy Signing Link"
						icon="files"
						size="sm"
						class="justify-self-end"
						(click)="copySigningLink(recipient)"
					/>
				</li>
			}
		</ul>
	</div>
</ui-card>
